package org.catharsis.spendtel.feature.presentation.home

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.CheckCircle
import androidx.compose.material.icons.outlined.ErrorOutline
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.catharsis.spendtel.feature.presentation.expensereport.SpendTelReportColors

internal val paywallFeatures = listOf(
    "AI spending story from your bank statements",
    "Category trends, insights, and personality",
    "One report credit — use it whenever you're ready",
)

@Composable
internal fun PaywallFeatureList(
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(18.dp),
        color = SpendTelReportColors.canvasDark,
    ) {
        Column(
            modifier = Modifier.padding(horizontal = 18.dp, vertical = 16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            paywallFeatures.forEach { feature ->
                Row(
                    verticalAlignment = Alignment.Top,
                ) {
                    Icon(
                        imageVector = Icons.Outlined.CheckCircle,
                        contentDescription = null,
                        tint = SpendTelReportColors.sage,
                        modifier = Modifier
                            .padding(top = 2.dp)
                            .size(18.dp),
                    )
                    Text(
                        text = feature,
                        modifier = Modifier.padding(start = 10.dp),
                        style = MaterialTheme.typography.bodyMedium,
                        color = SpendTelReportColors.ink,
                        lineHeight = 20.sp,
                    )
                }
            }
        }
    }
}

@Composable
internal fun PaywallPriceCard(
    price: String,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(18.dp),
        color = SpendTelReportColors.violet.copy(alpha = 0.1f),
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 20.dp, vertical = 16.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column {
                Text(
                    text = "One additional report",
                    style = MaterialTheme.typography.labelMedium,
                    color = SpendTelReportColors.inkMuted,
                )
                Text(
                    text = "Pay per story",
                    style = MaterialTheme.typography.bodySmall,
                    color = SpendTelReportColors.inkMuted,
                )
            }
            Text(
                text = price,
                style = MaterialTheme.typography.headlineMedium,
                fontWeight = FontWeight.Bold,
                color = SpendTelReportColors.violet,
            )
        }
    }
}

@Composable
internal fun PaywallErrorBanner(
    message: String,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(14.dp),
        color = SpendTelReportColors.increase.copy(alpha = 0.1f),
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 14.dp, vertical = 12.dp),
            verticalAlignment = Alignment.Top,
        ) {
            Icon(
                imageVector = Icons.Outlined.ErrorOutline,
                contentDescription = null,
                tint = SpendTelReportColors.increase,
                modifier = Modifier
                    .padding(top = 1.dp)
                    .size(20.dp),
            )
            Text(
                text = message,
                modifier = Modifier.padding(start = 10.dp),
                style = MaterialTheme.typography.bodySmall,
                fontWeight = FontWeight.Medium,
                color = SpendTelReportColors.increase,
                lineHeight = 18.sp,
            )
        }
    }
}
